import React from 'react';

import TextSpellcheckIcon from '@atlaskit/icon/core/text-spellcheck';

export const FixSpellingIcon = (): React.JSX.Element => (
	<TextSpellcheckIcon label="" color="currentColor" spacing="spacious" />
);
